import { render, staticRenderFns } from "./roi-map-item.vue?vue&type=template&id=aec8c0a6&scoped=true&"
import script from "./roi-map-item.vue?vue&type=script&lang=ts&"
export * from "./roi-map-item.vue?vue&type=script&lang=ts&"
import style0 from "./roi-map-item.vue?vue&type=style&index=0&id=aec8c0a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec8c0a6",
  null
  
)

export default component.exports